let state = {
    id: '',
    openId: '', // wx openid
    token: '', // wx token
    wxname: '',
    wxnickName: '',
    wxavatar: '',
    wxemail: '',
    wxsex: '',
    wxcity: '',
    wxprovince: '',
    wxcountry: '',
    appId: '',
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/wxAuth/state.js